"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const invariant_1 = __importDefault(require("invariant"));
const lodash_1 = __importDefault(require("lodash"));
const api_1 = __importDefault(require("./api"));
const client_1 = __importDefault(require("./client"));
const AnalystPersistence_1 = __importDefault(require("./src/AnalystPersistence"));
class Analyst extends AnalystPersistence_1.default {
    constructor(params) {
        super(params);
        this.list = [];
        this.isUploading = false;
        this.uploadedID = 0;
        this.intervalCheck = () => {
            (0, invariant_1.default)(this instanceof Analyst, 'interval has wrong context reference.');
            if (this.isUploading)
                return null;
            if (this.uploadedID < this.id) {
                this.upload();
            }
        };
        this.isInitialized = false;
        this.app_key = params.app_key;
        if (params.url) {
            // it is better to bind client to context somehow
            client_1.default.defaults.baseURL = params.url;
        }
    }
    getId() {
        this.id++;
        return this.id;
    }
    upload() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isInitialized) {
                console.log('analyst is not initialized yet. Dont upload');
                return null;
            }
            if (this.isUploading)
                return false;
            const { list, uploadedID } = this;
            let listToUpload = lodash_1.default.clone(list);
            const lastUploadIndexId = lodash_1.default.findIndex(list, (item) => item.id === uploadedID);
            if (lastUploadIndexId !== -1) {
                listToUpload = lodash_1.default.filter(listToUpload, (item, index) => index > lastUploadIndexId);
            }
            try {
                this.isUploading = true;
                yield api_1.default.collect(listToUpload, {
                    key: this.app_key,
                });
                const lastItem = lodash_1.default.last(listToUpload);
                this.uploadedID = lastItem.id;
                // todo probably here we should delete list
                this.savePersistedConfig();
            }
            catch (e) {
            }
            finally {
                this.isUploading = false;
            }
        });
    }
    addItem(type, data) {
        const metadata = {
            client_id: this.client_id,
            id: this.getId(),
            date: Date.now(),
            user_id: this.user_id,
        };
        this.list.push(Object.assign({ type, data }, metadata));
        this.upload();
    }
    track(event, params) {
        this.addItem('event', { event, params });
    }
    identify(user_id, params) {
        (0, invariant_1.default)(user_id, 'user_id is invalid');
        this.user_id = user_id;
        this.addItem('identify', { user_id, params });
    }
    reset() {
        this.addItem('reset');
        this.setupNewClient();
        this.resetStore();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInitialized)
                return null;
            yield this.initConfig();
            this.interval = setInterval(this.intervalCheck, 3000);
            this.isInitialized = true;
        });
    }
}
exports.default = Analyst;
